import React from "react";
import PropTypes from "prop-types";
import AddToRequisitionList from "../AddToRequisitionList";
import { useFormData } from "theme/components/atoms/Form/Form/Form";
import {
  productPropTypes,
  selectedConfigurableOptionsPropTypes,
} from "../AddToRequisitionList/EnhanceAddToRequisitionList";

/** @type {React.FunctionComponent<PropTypes.InferProps<typeof propTypes>>} */
const AddProductToRequisitionList = ({
  idPrefix = "",
  product,
  selectedConfigurableOptions,
  selectedCustomOptions,
  selectedBundleOptions,
  size,
  showOptionsModalIfNotFullyConfigured,
}) => {
  const quantity = useFormData()?.quantity || 1;

  return (
    <AddToRequisitionList
      id={`${idPrefix ? `${idPrefix}-` : ""}${product.sku}`}
      size={size}
      items={[
        {
          product,
          selectedConfigurableOptions,
          selectedCustomOptions,
          selectedBundleOptions,
          quantity,
        },
      ]}
      showOptionsModalIfNotFullyConfigured={
        showOptionsModalIfNotFullyConfigured
      }
    />
  );
};

const propTypes = {
  idPrefix: PropTypes.string,
  product: productPropTypes,
  selectedConfigurableOptions: selectedConfigurableOptionsPropTypes.isRequired,
  size: PropTypes.string,
};

AddProductToRequisitionList.propTypes = propTypes;

export default AddProductToRequisitionList;
